"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ErrorMessage;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _box = _interopRequireDefault(require("@ux/box"));
var _text = _interopRequireDefault(require("@ux/text"));
var _merchButton = require("@site/pattern-library-core/merch-button");
var _traffic = require("@site/pattern-library-utils/traffic");
var _leadGenScript = require("@site/pattern-library-utils/lead-gen-script");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ErrorMessage({
  buttonText = 'Retry',
  eid,
  title,
  message,
  image,
  source
}) {
  (0, _react.useEffect)(() => {
    (0, _traffic.logEvent)({
      eid: `${eid}.error.impression`,
      type: 'impression',
      properties: {
        source,
        sourceApp: _leadGenScript.SOURCE_APP
      }
    });
  }, []);
  return /*#__PURE__*/_react.default.createElement(_box.default, {
    blockAlignChildren: "center",
    blockPadding: "md",
    gap: "sm",
    inlineAlignChildren: "center",
    inlinePadding: "sm",
    orientation: "vertical"
  }, image && /*#__PURE__*/_react.default.createElement("img", {
    src: image.url,
    alt: image.altText,
    height: image.height,
    width: image.width
  }), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_text.default.h3, {
    as: "title",
    text: title,
    size: 5
  }), /*#__PURE__*/_react.default.createElement(_text.default.p, {
    text: message,
    size: 1
  }), /*#__PURE__*/_react.default.createElement(_merchButton.NSMerchButton, {
    id: 'lead-gen-error-retry-button',
    text: buttonText,
    size: 'small',
    width: 'auto',
    design: 'primary',
    "data-cy": "lead-gen-error-retry-button",
    "data-testid": "lead-gen-error-retry-button",
    onClick: () => window.location.reload(),
    "data-eid": `${eid}.error.click`,
    "aria-label": buttonText
  }));
}
ErrorMessage.propTypes = {
  buttonText: _propTypes.default.string,
  eid: _propTypes.default.string.isRequired,
  image: _propTypes.default.shape({
    height: _propTypes.default.number,
    width: _propTypes.default.number,
    url: _propTypes.default.string.isRequired,
    altText: _propTypes.default.string.isRequired
  }),
  message: _propTypes.default.string.isRequired,
  title: _propTypes.default.string.isRequired,
  source: _propTypes.default.string.isRequired
};